// libs
import React, { useCallback, useContext } from "react";

// widgets
import { GenericError, useEffectOnce } from "@swiggy-private/core-ui";

// components
import CommonUIWrapper from "@payment-client/components/common-ui-wrapper/CommonUIWrapper";
import CommonHeaderContent from "@payment-client/components/common-header-content/CommonHeaderContent";

// contexts
import { AnalyticsContext, CheckoutRoute, useNavigate } from "@swiggy-private/checkout-core";

// helpers
import { impressionErrorScreen } from "@payment-client/components/show-payments/components/review-bill-details-renderer/helpers/analytics";

const TEXT = {
    PAGE_TITLE: "Review Plan & Bill Details",
    TITLE: "Something went wrong",
    MESSAGE: "Please try again later",
    ACTION_TEXT: "Try again",
};

const ErrorScreen = () => {
    const { impressionEvent } = useContext(AnalyticsContext);
    const navigate = useNavigate();

    useEffectOnce(() => {
        impressionErrorScreen(impressionEvent);
    });

    const handleActionClick = useCallback(() => {
        navigate(CheckoutRoute.PAYMENTS_INDEX);
    }, [navigate]);

    return (
        <CommonUIWrapper
            header={<CommonHeaderContent title={TEXT.PAGE_TITLE} grayscale />}
            content={
                <GenericError
                    title={TEXT.TITLE}
                    message={TEXT.MESSAGE}
                    action={{
                        text: TEXT.ACTION_TEXT,
                        onClick: handleActionClick,
                    }}
                />
            }
        />
    );
};

export default ErrorScreen;
